import React from 'react';
import { BsFolderPlus } from '@react-icons/all-files/bs/BsFolderPlus';

import { decorateComponent } from '../../../documentComponents';
import { TabItem } from './TabItem';
import { TabItemInspector } from './TabItem.Inspector';

const TabOnButtonNode = {
  key: null,
  type: 'tabButton',
  props: { state: 'on' },
  children: [],
};

const TabOffButtonNode = {
  key: null,
  type: 'tabButton',
  props: { state: 'off' },
  children: [],
};

const TabContentNode = {
  key: null,
  type: 'tabContent',
  props: {},
  children: [],
};

export default decorateComponent(TabItem, 'block', {
  id: 'tabItem',
  label: '탭 항목',
  allowedParent: ['tab'],
  allowedChildren: [],
  defaultProps: {
    children: [TabOnButtonNode, TabOffButtonNode, TabContentNode],
  },
  renderIcon: () => <BsFolderPlus />,
  renderInspector: TabItemInspector,
});
